class AgeGateModal extends HTMLElement {
  constructor() {
    super();
    this.connectedCallback();
  }

  connectedCallback() {
    this.ageGateSection = document.querySelector(".age-gate");
    this.confirmBtn = document.querySelector(".age-gate__button-confirm");
    this.rejectBtn = document.querySelector(".age-gate__button-reject");
    this.body = document.body;

    if (localStorage.getItem("enoughAge") !== "true") {
      this.ageGateSection.classList.remove("age-gate--disable");
      this.body.classList.add("body--no-scroll");
    } else {
      this.ageGateSection.classList.add("age-gate--disable");
    }

    if (this.confirmBtn) {
      this.confirmBtn.addEventListener("click", this.confirm.bind(this));
    }

    if (this.rejectBtn) {
      this.rejectBtn.addEventListener("click", this.reject.bind(this));
    }
  }

  confirm() {
    localStorage.setItem("enoughAge", "true");
    this.ageGateSection.classList.add("age-gate--disable");
    this.body.classList.remove("body--no-scroll");
  }

  reject() {
    localStorage.setItem("enoughAge", "false");
    window.location.href = "https://www.google.com/";
  }
}

customElements.define("age-gate-modal", AgeGateModal);
